import React from 'react';
import { ArrowButton } from '../components/ui/ArrowButton';
export function NotFound() {
  return <section className="bg-paper px-5 pb-32 pt-48 text-center" data-id="element-671" data-mp="w3hom1yqg9dy">
      <p className="text-7xl font-medium tracking-tight text-brass-dark" data-id="element-672" data-mp="w643ynrv7t6q">404</p>
      <h1 className="mt-4 text-3xl font-medium" data-id="element-673" data-mp="104js4uzon7lq">Page introuvable</h1>
      <p className="mt-3 text-muted" data-id="element-674" data-mp="1560run6fko0q">La page que vous cherchez n’existe pas ou a été déplacée.</p>
      <ArrowButton to="/" className="mt-8" data-id="element-675" data-mp="1a2zekknrlsow">
        Retour à l’accueil
      </ArrowButton>
    </section>;
}